import React from 'react';
import PropTypes from 'prop-types';
import { SectionColumn, SectionWrapper } from './styled';
import DesignerListFilledSection from './DesignerListFilledSection';
import DesignerListEmptySection from './DesignerListEmptySection';

const DesignerListSection = ({ designers, letter }) => {
  const numberOfColumns = 4;

  const designersPerColumn = Math.ceil(designers.length / numberOfColumns);
  const groupedArray = designers.reduce((prev, curr, idx) => {
    const column = Math.floor(idx / designersPerColumn);

    if (prev[column] === undefined) {
      prev[column] = [];
    }

    prev[column].push(curr);
    return prev;
  }, []);

  const sectionEmpty = groupedArray.length === 0;

  return (
    <SectionWrapper>
      <SectionColumn center={sectionEmpty}>
        {sectionEmpty ? (
          <DesignerListEmptySection letter={letter} />
        ) : (
          <DesignerListFilledSection groupedArray={groupedArray} letter={letter} />
        )}
      </SectionColumn>
    </SectionWrapper>
  );
};

DesignerListSection.propTypes = {
  designers: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  letter: PropTypes.string.isRequired,
};

DesignerListSection.defaultProps = {
  designers: [],
};

export default DesignerListSection;
